const initialState = {
    loaded: false,
    events: [],
    tasks: [],
    taskPaginationData: {},
    completedTasks: [],
    completedTasksPaginationData: {}
};

export default function activeUser(state = initialState, action = {}) {
    switch (action.type) {
        case 'ACTIVE_USER_LOAD_SUCCESS':
            var user = action.result;

            return {
                ...state,
                loaded: true,
                user: {...user, isFg: user.organisationName == 'Fergus'},
                error: null
            };
        case 'UNMOUNT_ACTIVE_USER':
            return initialState;
        case 'ACTIVE_USER_LOAD_FAIL':
            return {
                ...state,
                loaded: false,
                user: null,
                error: action.error
            };
        case 'USER_COMPLETED_TASKS_LOAD_SUCCESS':
            var {result} = action;

            var completedTasks = [0,1].includes(result.paginationData.currentPage) ? result.events : state.completedTasks.concat(result.events);

            return {
                ...state,
                completedTasks,
                completedTasksPaginationData: result.paginationData
            };
        case 'USER_TASKS_LOAD_SUCCESS':
            // TODO: concat when paginating, replace when not
            return {
                ...state,
                tasks: action.result.events,
                taskPaginationData: action.result.paginationData
            };
        case 'UPDATE_SCHEDULE_SUCCESS':
            var schedule = action.result;

            // if the updated schedule doesn't contain the activeUsers id in assignedUsers we need to filter it the updated schedule out

            return {
                ...state,
                completedTasks: state.completedTasks.map(t => t.id == schedule.id ? schedule : t)
            };
        case 'RECORD_PHONE_CALL_COMPLETE_SUCCESS':
            return {
                ...state,
                tasks: state.tasks.filter(t => t.id != action.result.id)
            };
        case 'SCHEDULE_MARKED_COMPLETE_SUCCESS':
            var scheduleId = action.result.scheduleMarkedAsCompletedId;
            var tasks = state.tasks.filter(t => t.scheduleId != scheduleId);
            return {...state, tasks};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./app/reducers/activeUser.js